module.exports = __webpack_public_path__ + "static/comission-3-394b437360c106302d8c2ca614b21071.mp4";